/* Header behaviour: sticky/compact state, header height CSS var, scroll-up mode, bottom-nav height. */
(() => {
  'use strict';
  // Resolved locally rather than through Purr.byRole: the header must keep working even if
  // purr-core.js fails to load, and it only ever needs roles, never the legacy id fallback.
  const byRole = (role) => document.querySelector('[data-purr-role="' + role + '"]');
  const header = byRole('header');
  if (!header) return;
  const root = document.documentElement;
  const mode = header.dataset.sticky || 'always';
  let lastY = window.scrollY;
  let ticking = false;

  const setVars = () => {
    root.style.setProperty('--purr-header-h', header.offsetHeight + 'px');
    const nav = byRole('bottom-nav');
    const visible = nav && getComputedStyle(nav).display !== 'none';
    root.style.setProperty('--purr-bottom-nav-h', visible ? nav.offsetHeight + 'px' : '0px');
    document.body.classList.toggle('purr-has-bottom-nav', !!visible);
  };

  const update = () => {
    const y = window.scrollY;
    header.classList.toggle('is-scrolled', y > 8);
    if (mode === 'scroll-up') {
      const down = y > lastY && y > header.offsetHeight + 40;
      header.classList.toggle('is-hidden', down);
    }
    lastY = y;
    ticking = false;
  };

  window.addEventListener('scroll', () => { if (!ticking) { ticking = true; requestAnimationFrame(update); } }, { passive: true });
  window.addEventListener('resize', setVars);
  new ResizeObserver(setVars).observe(header);
  setVars(); update();

  // Close open header disclosures when a drawer/dialog opens
  document.addEventListener('purr:drawer:open', () => header.querySelectorAll('purr-disclosure[open]').forEach((d) => d.close()));
  document.addEventListener('purr:dialog:open', () => header.querySelectorAll('purr-disclosure[open]').forEach((d) => d.close()));

  // Mega menu: close on focus leaving the panel (keyboard users)
  header.querySelectorAll('purr-disclosure').forEach((d) => {
    d.addEventListener('focusout', (e) => { if (!d.contains(e.relatedTarget)) d.close(); });
  });
})();
